export const DEFAULT_FEES = {
  CARD_TRANSACTION_PERCENTAGE: '2.9',
  CARD_FIXED: '0.30',
  ACH_TRANSACTION_PERCENTAGE: '0.8',
} as const;
